import { memo, SyntheticEvent } from 'react';
import Select, { Option } from 'presentations/views/components/atoms/Select';
import {
  defaultLocale,
  supportLocales,
  translateInComponent,
} from 'infras/i18n';
import { useRouter } from 'next/router';

// i18n
import translations from './i18n.json';

interface Props {
  onChangeLocale: (e: SyntheticEvent<HTMLInputElement>) => void;
  className?: string;
}

const Component = memo((props: Props) => {
  const t = translateInComponent(translations);
  const router = useRouter();
  const localeOptions: Option[] = supportLocales.map((l) => ({
    text: t(l),
    value: l,
  }));
  return (
    <Select
      size="small"
      name="locale"
      className={props.className}
      value={router.locale || defaultLocale}
      onChange={props.onChangeLocale}
      options={localeOptions}
    />
  );
});

export default Component;
